import React from 'react';
import styled from 'styled-components';
import { Button as MuiButton } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';

export const Button = styled(MuiButton).attrs({
  endIcon: <FilterList />,
})`
  font-family: Poppins;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
`;
